export {
  default as AvatarStack,
  MAX_AVATARS,
  hasAvatars,
} from './avatar-stack';
export type { AvatarStackProps, StackedAgent } from './avatar-stack';
